import React from "react";
import { MotionConfig } from "framer-motion";
import { AuthProvider } from "./context/AuthContext";
import { ThemeProvider } from "./context/ThemeContext";
import { LocaleProvider } from "./context/LocaleContext";
import { UiVersionProvider } from "./context/UiVersionContext";

/**
 * The providers every page sits inside, shared by gatsby-browser and gatsby-ssr so the two
 * trees can't drift apart — a mismatch there shows up as a hydration warning and, worse, as a
 * flash of the wrong tree on first paint.
 *
 * `reducedMotion="user"` is the one line that makes the OS setting actually reach this app. The
 * stylesheet has honoured it for a while, but roughly nine views animate through framer-motion's
 * `motion.*` components, and those are driven in JS — no media query touches them. This tells
 * framer to drop transform and opacity animations for anyone who has asked for less motion,
 * everywhere, rather than each view remembering to check.
 */
export const RootWrapper = ({ element }) => (
  <MotionConfig reducedMotion="user">
    <ThemeProvider>
      {/* LocaleProvider sits inside AuthProvider, not beside it: the account is what holds the
          language, so the provider has to be able to read `user` to let the server's answer win
          over the local copy. */}
      <AuthProvider>
        {/* UiVersionProvider sits inside AuthProvider for the same reason, and inside ThemeProvider
            with it: it refetches the version when the signed-in person changes, so it has to see
            `user`. It wraps LocaleProvider rather than sitting under it because it needs nothing
            from the language, and every screen below — v1 or v2 — needs both. */}
        <UiVersionProvider>
          <LocaleProvider>{element}</LocaleProvider>
        </UiVersionProvider>
      </AuthProvider>
    </ThemeProvider>
  </MotionConfig>
);
